module.exports = __webpack_public_path__ + "img/qg4_01.8c0eccee.png";